












import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryShopUserList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { UserRoleFormat } from '@/utils/tyepconvert'
import ChangeRoleDialog from './ChangeRoleDialog.vue'
import constan from '@/utils/constant'
import MCBindMedicneCabinetDialog from '@/views/medicineCabinet/MCBindMedicneCabinetDialog.vue'
import InvestorIncomeDialog from './InvestorIncomeDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    ChangeRoleDialog,
    MCBindMedicneCabinetDialog,
    InvestorIncomeDialog
  },
})
export default class UserList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '手机号', param: 'mobilePhone' },
    { title: '昵称', param: 'nickname' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '用户ID', param: 'id' },
    { title: '手机号', param: 'mobilePhone' },
    { title: '昵称', param: 'nickname' },
    // { title: '角色', param: 'role', formatter: UserRoleFormat },
    // { title: '房子编号', param: 'houseCode' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      operation: [
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  private openChangeRole(data: any){
    const d = this.$refs.ChangeRoleDialog as ChangeRoleDialog
    d.open(data)
  }

  private openIncomeDesc(data: any){
    const d = this.$refs.InvestorIncomeDialog as InvestorIncomeDialog
    d.open(data)
  }

  private openBindMedicneCabinet(data: any){
    // 绑定药柜
    const d = this.$refs.MCBindMedicneCabinetDialog as MCBindMedicneCabinetDialog
    d.open(data)
  }


  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryShopUserList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

}
